import logoutUser from "./logoutUser";
import registerUser from "./registerUser";
import loginUser from "./loginUser";
import isUserLoggedIn from "./isUserLoggedIn";
import retrieveUser from "./retrieveUser";
import createPost from "./createPost";
import retrievePosts from "./retrievePosts";
import removePost from "./removePost";
import modifyPost from "./modifyPost";
import createComment from "./createComment";
import retrieveComments from "./retrieveComments";
import removeComment from "./removeComment";
import modifyComment from "./modifyComment";
import toggleLikePost from "./toggleLikePost";
import getLoggedInUserId from "./getLoggedInUserId";
import retrieveProducts from "./retrieveProducts";
import addCart from "./addCart";
import removeCart from "./removeCart";
import modifyCart from "./modifyCart";
import retrieveCart from "./retrieveCart";
import createOrder from "./createOrder";
import redirectToCheckout from "./redirectToCheckout";
import authenticateUser from "./authenticateUser";
import retrieveOrders from "./retrieveOrders";
import modifyOrder from "./modifyOrder";
import sendVerifyEmail from "./sendVerifyEmail";
import retrieveUserOrders from "./retrieveUserOrders";
import resetPassword from "./resetPassword";
import requestPasswordEmail from "./requestPasswordEmail";
import sendOrderEmail from "./sendOrderEmail";
const logic = {
    registerUser,
    logoutUser,
    loginUser,
    isUserLoggedIn,
    retrieveUser,
    createPost,
    retrievePosts,
    removePost,
    modifyPost,
    createComment,
    retrieveComments,
    removeComment,
    modifyComment,
    toggleLikePost,
    getLoggedInUserId,
    retrieveProducts,
    addCart,
    removeCart,
    modifyCart,
    retrieveCart,
    createOrder,
    redirectToCheckout,
    authenticateUser,
    retrieveOrders,
    modifyOrder,
    sendVerifyEmail,
    retrieveUserOrders,
    resetPassword,
    requestPasswordEmail,
    sendOrderEmail

}

export default logic